import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const deleteJourney = (id: number) => {
  return restApiClient.url(constructApiUrl(API.products.deleteJourney.url, { id })).delete()
}
